export default __webpack_public_path__ + "static/media/banner-right-bg.b71cd0ed.png";